<template>
  <v-dialog v-model="modal" scrollable>
    <v-card>
      <v-card-title>
        Sélection de personne physique
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <search-by
              :datasource="datasource"
              attr="nom"
              i18n="recherche.rechercheSimple.personnePhysique.search.nom"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <search-by
              :datasource="datasource"
              attr="prenoms"
              i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <search-by
              :datasource="datasource"
              attr="raisonSociale"
              i18n="recherche.rechercheSimple.personnePhysique.search.raisonSociale"
            />
          </v-col>
        </v-row>
        <datasource-table style="height:480px;" :datasource="datasource">
          <template #item.nom="{item}">
            <a @click="select(item)">
              {{ item.nom }}
            </a>
          </template>
          <template #item.prenoms="{item}">
            <a @click="select(item)">
              {{ item.prenoms }}
            </a>
          </template>
          <template #item.raisonSociale="{item}">
            <a @click="select(item)">
              {{ item.raisonSociale }}
            </a>
          </template>
        </datasource-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal" text>
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  props: {
    subtitle: {
      type: String,
    },
  },
  data() {
    const datasource = new Datasource('recherche/simple/contact', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
      args: {
        actif: true,
      },
      fields: [
        // ...this.fieldName,
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenoms',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: false,
        },
        {
          value: 'fonction',
          sortable: false,
        },
        {
          value: 'division',
          sortable: false,
        },
      ],
    });
    return {
      datasource,
      modal: false,
    };
  },
  methods: {
    show() {
      this.modal = true;
    },
    select(item) {
      this.modal = false;

      const valeur = {
        id: item.idPersonnePhysique,
        nom: item.nom,
        prenoms: item.prenoms,
      };

      this.$emit('input', valeur);
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>
